import React, { FC } from "react";
import { useAppSelector } from "../../../../../app";
import lastIndexForEntityIdSelector from "../../../../../annotation/selectors/lastIndexForEntityIdSelector";
import rowHasAdjacentAnnotationsForEntitySelector from "../../../../../annotation/selectors/rowHasAdjacentAnnotationsForEntitySelector";

type Props = {
  entityTypeId: string;
  index: number;
  shiftAnnotationHandler: (
    entityTypeId: string,
    index: number,
    direction: 1 | -1,
  ) => void;
};

const ShiftEntityAnnotation: FC<Props> = ({
  entityTypeId,
  index,
  shiftAnnotationHandler,
}) => {
  const lastIndex = useAppSelector((state) =>
    lastIndexForEntityIdSelector(state, { entityTypeId }),
  );

  const [previousRowHasAnnotation, nextRowHasAnnotation] = useAppSelector(
    (state) =>
      rowHasAdjacentAnnotationsForEntitySelector(state, {
        entityId: entityTypeId,
        groupBlockIndex: index,
      }),
  );

  const canShiftUp = index > 1 && !previousRowHasAnnotation;
  const canShiftDown = index < lastIndex && !nextRowHasAnnotation;

  if (!canShiftUp && !canShiftDown) {
    return null;
  }

  return (
    <>
      {canShiftUp && (
        <span
          className="bi bi-caret-up-fill shift-icon up"
          onClick={() => shiftAnnotationHandler(entityTypeId, index, -1)}
        />
      )}
      {canShiftDown && (
        <span
          className="bi bi-caret-down-fill shift-icon down"
          onClick={() => shiftAnnotationHandler(entityTypeId, index, 1)}
        />
      )}
    </>
  );
};

export default ShiftEntityAnnotation;
